import { Button, Flex, Heading } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

export const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Flex direction="column" align="center" gap={5}>
      <Heading color="red.600" fontWeight="bold" size="4xl">
        404
      </Heading>
      <Heading color="red.600" fontWeight="bold" size="2xl">
        Page not found
      </Heading>
      <Button variant="primary" onClick={() => navigate("/")}>
        Return Home
      </Button>
    </Flex>
  );
};
